import script from "./sub-product.vue?vue&type=script&setup=true&lang=js"
export * from "./sub-product.vue?vue&type=script&setup=true&lang=js"

import "./sub-product.vue?vue&type=style&index=0&id=7c33e832&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c33e832"]])

export default __exports__